/**
 * Página "Relatórios" do CRM (lista de 02/11): textos em `crm.relatorios` (pt, en, es com tú). O relatório de sempre
 * (`crm.relatorio`, `/crm/atividades/relatorio`) segue à parte; esta página tem link para ele.
 */
export const relatoriosPt = {
  titulo: 'Relatórios',
  subtitulo: 'Funil de hoje, evolução mês a mês, origem dos negócios e negócios parados',
  verCompleto: 'Ver relatório completo',
  recarregar: 'Recarregar',
  recarregado: 'Relatórios recarregados',
  funil: 'Funil de vendas',
  responsavel: 'Responsável',
  todas: 'Todas as negociações',
  minhas: 'Minhas negociações',
  periodo: 'Período (meses)',
  mesDe: 'Do mês',
  mesAte: 'Até o mês',
  periodoInvalido: 'O último mês deve ser igual ou depois do primeiro',
  periodoLongo: 'Escolha até 24 meses',
  periodoPadrao: 'Últimos 12 meses',
  carregando: 'Carregando o bloco...',
  semFunis: 'Nenhum funil ativo. Crie um funil em Configurações do CRM para ver os relatórios.',
  vazio: 'Sem dados para os filtros escolhidos.',
  exportar: 'Exportar CSV: {{bloco}}',
  exportado: 'CSV exportado',
  arquivo: 'relatorios-{{bloco}}.csv',
  blocos: {
    funil: 'Funil de hoje',
    evolucao: 'Evolução mês a mês',
    origem: 'Origem',
    parados: 'Negócios parados',
  },
  funilHoje: {
    etapa: 'Etapa',
    abertas: 'Abertos',
    valor: 'Valor',
    pausadas: 'Pausadas',
    total: 'Total',
    ajuda: 'Negociações abertas hoje em cada etapa, sem as pausadas. Valores por moeda, nunca somados entre moedas.',
    semEtapas: 'O funil não tem etapas abertas.',
    pausadasNota_one: 'Fora da contagem e do valor: {{n}} pausada.',
    pausadasNota_other: 'Fora da contagem e do valor: {{n}} pausadas.',
  },
  evolucao: {
    mes: 'Mês',
    leads: 'Leads novos',
    vendas: 'Vendas',
    perdas: 'Perdas',
    taxa: 'Taxa de fechamento',
    recorrente: 'Valor recorrente',
    pontual: 'Valor pontual',
    total: 'Valor vendido',
    totalPeriodo: 'Período',
    ajuda: 'Lead novo é a negociação criada no mês. Taxa de fechamento = vendas ÷ (vendas + perdas) fechadas no mês; "-" quando nada fechou. Recorrente é a soma dos itens recorrentes como estão, sem multiplicar por meses.',
    semFechamento: '-',
  },
  origem: {
    fonte: 'Fonte',
    leads: 'Leads',
    vendas: 'Vendas',
    valor: 'Valor vendido',
    semFonte: 'Sem fonte',
    ajuda: 'Leads e vendas por Fonte da negociação, no período escolhido.',
    truncado: 'Há mais fontes do que cabem aqui: mostramos as {{n}} com mais movimento.',
  },
  parados: {
    negociacao: 'Negociação',
    etapa: 'Etapa',
    responsavel: 'Responsável',
    valor: 'Valor',
    motivo: 'Motivo',
    ultimoMovimento: 'Último movimento',
    dias_one: '{{count}} dia',
    dias_other: '{{count}} dias',
    hoje: 'hoje',
    tarefaVencidaEm: 'Tarefa vencida desde {{data}}',
    filtroMotivo: 'Motivo',
    todosMotivos: 'Todos os motivos',
    motivos: {
      sem_proxima_tarefa: 'Sem próxima tarefa',
      tarefa_vencida: 'Tarefa vencida',
      sem_movimento: 'Sem movimento há 7 dias',
    },
    ajuda: 'Negociações abertas (sem as pausadas) sem próxima tarefa, com tarefa vencida ou sem movimento há 7 dias corridos. Movimento é criação da negociação, mudança de etapa, tarefa criada ou concluída, anotação, e-mail ou mensagem do histórico.',
    total_one: '{{count}} negócio parado',
    total_other: '{{count}} negócios parados',
    nenhum: 'Nenhum negócio parado nos filtros escolhidos.',
    pagina: 'Página {{pagina}} de {{paginas}}',
    anterior: 'Página anterior',
    proxima: 'Próxima página',
    truncadoCsv: 'O CSV leva os {{n}} primeiros negócios; filtre por motivo ou responsável para ver o resto.',
    abrir: 'Abrir a negociação {{nome}}',
  },
  csv: {
    item: 'Item',
  },
};

export const relatoriosEn: typeof relatoriosPt = {
  titulo: 'Reports',
  subtitulo: 'Pipeline today, month by month, where deals come from and stalled deals',
  verCompleto: 'View full report',
  recarregar: 'Reload',
  recarregado: 'Reports reloaded',
  funil: 'Sales pipeline',
  responsavel: 'Owner',
  todas: 'All deals',
  minhas: 'My deals',
  periodo: 'Period (months)',
  mesDe: 'From month',
  mesAte: 'To month',
  periodoInvalido: 'The last month must be the same as or after the first',
  periodoLongo: 'Choose up to 24 months',
  periodoPadrao: 'Last 12 months',
  carregando: 'Loading the block...',
  semFunis: 'No active pipeline. Create one in CRM settings to see the reports.',
  vazio: 'No data for the chosen filters.',
  exportar: 'Export CSV: {{bloco}}',
  exportado: 'CSV exported',
  arquivo: 'reports-{{bloco}}.csv',
  blocos: {
    funil: 'Pipeline today',
    evolucao: 'Month by month',
    origem: 'Source',
    parados: 'Stalled deals',
  },
  funilHoje: {
    etapa: 'Stage',
    abertas: 'Open',
    valor: 'Value',
    pausadas: 'Paused',
    total: 'Total',
    ajuda: 'Deals open today in each stage, without the paused ones. Values by currency, never added across currencies.',
    semEtapas: 'The pipeline has no open stages.',
    pausadasNota_one: 'Left out of the count and the value: {{n}} paused.',
    pausadasNota_other: 'Left out of the count and the value: {{n}} paused.',
  },
  evolucao: {
    mes: 'Month',
    leads: 'New leads',
    vendas: 'Sales',
    perdas: 'Losses',
    taxa: 'Closing rate',
    recorrente: 'Recurring value',
    pontual: 'One-time value',
    total: 'Value sold',
    totalPeriodo: 'Period',
    ajuda: 'A new lead is a deal created in the month. Closing rate = sales ÷ (sales + losses) closed in the month; "-" when nothing closed. Recurring is the sum of the recurring items as they are, not multiplied by months.',
    semFechamento: '-',
  },
  origem: {
    fonte: 'Source',
    leads: 'Leads',
    vendas: 'Sales',
    valor: 'Value sold',
    semFonte: 'No source',
    ajuda: 'Leads and sales by the deal Source, in the chosen period.',
    truncado: 'There are more sources than fit here: we show the {{n}} with the most activity.',
  },
  parados: {
    negociacao: 'Deal',
    etapa: 'Stage',
    responsavel: 'Owner',
    valor: 'Value',
    motivo: 'Reason',
    ultimoMovimento: 'Last activity',
    dias_one: '{{count}} day',
    dias_other: '{{count}} days',
    hoje: 'today',
    tarefaVencidaEm: 'Task overdue since {{data}}',
    filtroMotivo: 'Reason',
    todosMotivos: 'All reasons',
    motivos: {
      sem_proxima_tarefa: 'No next task',
      tarefa_vencida: 'Overdue task',
      sem_movimento: 'No activity for 7 days',
    },
    ajuda: 'Open deals (not paused) with no next task, with an overdue task or with no activity for 7 calendar days. Activity is the deal being created, a stage change, a task created or completed, a note, an email or a message in the history.',
    total_one: '{{count}} stalled deal',
    total_other: '{{count}} stalled deals',
    nenhum: 'No stalled deals for the chosen filters.',
    pagina: 'Page {{pagina}} of {{paginas}}',
    anterior: 'Previous page',
    proxima: 'Next page',
    truncadoCsv: 'The CSV has the first {{n}} deals; filter by reason or owner to see the rest.',
    abrir: 'Open the deal {{nome}}',
  },
  csv: {
    item: 'Item',
  },
};

export const relatoriosEs: typeof relatoriosPt = {
  titulo: 'Informes',
  subtitulo: 'Embudo de hoy, evolución mes a mes, origen de los negocios y negocios detenidos',
  verCompleto: 'Ver el informe completo',
  recarregar: 'Recargar',
  recarregado: 'Informes recargados',
  funil: 'Embudo de ventas',
  responsavel: 'Responsable',
  todas: 'Todas las negociaciones',
  minhas: 'Mis negociaciones',
  periodo: 'Período (meses)',
  mesDe: 'Desde el mes',
  mesAte: 'Hasta el mes',
  periodoInvalido: 'El último mes debe ser igual o posterior al primero',
  periodoLongo: 'Elige hasta 24 meses',
  periodoPadrao: 'Últimos 12 meses',
  carregando: 'Cargando el bloque...',
  semFunis: 'No hay ningún embudo activo. Crea uno en la configuración del CRM para ver los informes.',
  vazio: 'Sin datos para los filtros elegidos.',
  exportar: 'Exportar CSV: {{bloco}}',
  exportado: 'CSV exportado',
  arquivo: 'informes-{{bloco}}.csv',
  blocos: {
    funil: 'Embudo de hoy',
    evolucao: 'Evolución mes a mes',
    origem: 'Origen',
    parados: 'Negocios detenidos',
  },
  funilHoje: {
    etapa: 'Etapa',
    abertas: 'Abiertos',
    valor: 'Valor',
    pausadas: 'Pausadas',
    total: 'Total',
    ajuda: 'Negociaciones abiertas hoy en cada etapa, sin las pausadas. Valores por moneda, nunca sumados entre monedas.',
    semEtapas: 'El embudo no tiene etapas abiertas.',
    pausadasNota_one: 'Fuera del conteo y del valor: {{n}} pausada.',
    pausadasNota_other: 'Fuera del conteo y del valor: {{n}} pausadas.',
  },
  evolucao: {
    mes: 'Mes',
    leads: 'Leads nuevos',
    vendas: 'Ventas',
    perdas: 'Pérdidas',
    taxa: 'Tasa de cierre',
    recorrente: 'Valor recurrente',
    pontual: 'Valor puntual',
    total: 'Valor vendido',
    totalPeriodo: 'Período',
    ajuda: 'Un lead nuevo es la negociación creada en el mes. Tasa de cierre = ventas ÷ (ventas + pérdidas) cerradas en el mes; "-" cuando nada se cerró. Recurrente es la suma de los ítems recurrentes tal como están, sin multiplicar por meses.',
    semFechamento: '-',
  },
  origem: {
    fonte: 'Fuente',
    leads: 'Leads',
    vendas: 'Ventas',
    valor: 'Valor vendido',
    semFonte: 'Sin fuente',
    ajuda: 'Leads y ventas por la Fuente de la negociación, en el período elegido.',
    truncado: 'Hay más fuentes de las que caben aquí: mostramos las {{n}} con más movimiento.',
  },
  parados: {
    negociacao: 'Negociación',
    etapa: 'Etapa',
    responsavel: 'Responsable',
    valor: 'Valor',
    motivo: 'Motivo',
    ultimoMovimento: 'Último movimiento',
    dias_one: '{{count}} día',
    dias_other: '{{count}} días',
    hoje: 'hoy',
    tarefaVencidaEm: 'Tarea vencida desde {{data}}',
    filtroMotivo: 'Motivo',
    todosMotivos: 'Todos los motivos',
    motivos: {
      sem_proxima_tarefa: 'Sin próxima tarea',
      tarefa_vencida: 'Tarea vencida',
      sem_movimento: 'Sin movimiento hace 7 días',
    },
    ajuda: 'Negociaciones abiertas (sin las pausadas) sin próxima tarea, con tarea vencida o sin movimiento hace 7 días corridos. Movimiento es la creación de la negociación, un cambio de etapa, una tarea creada o completada, una nota, un correo o un mensaje del historial.',
    total_one: '{{count}} negocio detenido',
    total_other: '{{count}} negocios detenidos',
    nenhum: 'Ningún negocio detenido con los filtros elegidos.',
    pagina: 'Página {{pagina}} de {{paginas}}',
    anterior: 'Página anterior',
    proxima: 'Página siguiente',
    truncadoCsv: 'El CSV lleva los primeros {{n}} negocios; filtra por motivo o responsable para ver el resto.',
    abrir: 'Abrir la negociación {{nome}}',
  },
  csv: {
    item: 'Ítem',
  },
};
